import { configureStore } from "@reduxjs/toolkit";
import appReducer from '../features/appSlice';
import demoFormReducer from "../features/demoFormSlice";
import chatDemoReducer from '../features/playgroundDemoSlice'
import aiFormReducer from '../features/aiFormSlice'
// import dropdownReducer from '../feature/dropdownSlice'
import scrappedDataReducer from '../features/scrappedSlice'
import answersReducer from "../features/answerSlice";
export const store = configureStore({
    reducer: {
        app: appReducer,
        chatDemo: chatDemoReducer,
        demoForm: demoFormReducer,
        aiForm: aiFormReducer,
        // dropdown: dropdownReducer,
        scrappedData: scrappedDataReducer,
        answers: answersReducer,
    },
});